import { ExceptionPayload } from '../hooks/useChatWebsocket/useChatWebsocket.types';
import {
  AddManyMessagesWithoutConfirmationPayload,
  AddMessageWithoutConfirmationPayload,
  AddNotificationPayload,
  ChatCreatedPayload,
  ChatSocketReducerActions,
  CleanMessagesByChatIdPayload,
  CleanWebsocketMessageByMessageIdPayload,
  CleanWebsocketMessageByTempIdPayload,
  ConnectionRecoveredPayload,
  MessageReceivedPayload,
  RemoveChatToFetchPayload,
  RemoveChatToRemovePayload,
  RemoveNotificationsByMessageIdsPayload,
  RemovedFromChatPayload,
  UpdateMessageWithErrorPayload,
} from './chatSocketReducer.types';

export const addWsException = (payload: ExceptionPayload): ChatSocketReducerActions => ({
  type: 'WS_EXCEPTION',
  payload,
});

export const addMessageWithoutConfirmation = (
  payload: AddMessageWithoutConfirmationPayload,
): ChatSocketReducerActions => ({
  type: 'ADD_MESSAGE_WITHOUT_CONFIRMATION',
  payload,
});

export const addManyMessagesWithoutConfirmation = (
  payload: AddManyMessagesWithoutConfirmationPayload,
): ChatSocketReducerActions => ({
  type: 'ADD_MANY_MESSAGES_WITHOUT_CONFIRMATION',
  payload,
});

export const updateMessageWithError = (
  payload: UpdateMessageWithErrorPayload,
): ChatSocketReducerActions => ({
  type: 'UPDATE_MESSAGE_WITH_ERROR',
  payload,
});

export const messageReceived = (payload: MessageReceivedPayload): ChatSocketReducerActions => ({
  type: 'MESSAGE_RECEIVED',
  payload,
});

export const addNewNotification = (payload: AddNotificationPayload): ChatSocketReducerActions => ({
  type: 'ADD_NOTIFICATION',
  payload,
});

export const removeNotificationsByMessageIds = (
  payload: RemoveNotificationsByMessageIdsPayload,
): ChatSocketReducerActions => ({
  type: 'REMOVE_NOTIFICATIONS_BY_MESSAGE_IDS',
  payload,
});

export const cleanWebsocketMessagesByTempId = (
  payload: CleanWebsocketMessageByTempIdPayload,
): ChatSocketReducerActions => ({
  type: 'CLEAN_WEBSOCKET_MESSAGE_BY_TEMP_ID',
  payload,
});

export const cleanWebsocketMessagesByMessageId = (
  payload: CleanWebsocketMessageByMessageIdPayload,
): ChatSocketReducerActions => ({
  type: 'CLEAN_WEBSOCKET_MESSAGE_BY_MESSAGE_ID',
  payload,
});

export const cleanWebsocketMessagesByChatId = (
  payload: CleanMessagesByChatIdPayload,
): ChatSocketReducerActions => ({
  type: 'CLEAN_MESSAGES_BY_CHAT_ID',
  payload,
});

export const chatCreated = (payload: ChatCreatedPayload): ChatSocketReducerActions => ({
  type: 'CHAT_CREATED',
  payload,
});

export const removedFromChat = (payload: RemovedFromChatPayload): ChatSocketReducerActions => ({
  type: 'REMOVED_FROM_CHAT',
  payload,
});

export const resetState = (): ChatSocketReducerActions => ({
  type: 'RESET_STATE',
});

export const connectionRecovered = (
  payload: ConnectionRecoveredPayload,
): ChatSocketReducerActions => ({
  type: 'CONNECTION_RECOVERED',
  payload,
});

export const removeChatToFetch = (payload: RemoveChatToFetchPayload): ChatSocketReducerActions => ({
  type: 'REMOVE_CHAT_TO_FETCH',
  payload,
});

export const removeChatToRemove = (
  payload: RemoveChatToRemovePayload,
): ChatSocketReducerActions => ({
  type: 'REMOVE_CHAT_TO_REMOVE',
  payload,
});
